import { createContext, useContext, useEffect, useRef, useState } from "react";

const AudioContext = createContext();

export const AudioProvider = ({ children }) => {
  const audioRef = useRef(new Audio());

  const [isPlaying, setIsPlaying] = useState(
    localStorage.getItem("sound_enabled") === "true"
  );

  const [currentTrack, setCurrentTrack] = useState(
    localStorage.getItem("sound_track") || "ottoman"
  );

useEffect(() => {
  const audio = audioRef.current;

  audio.src = `/sounds/${currentTrack}.mp3`;
  audio.volume = 0.3;
  audio.loop = false; // loop'u biz yöneteceğiz

  const handleEnded = () => {
    audio.currentTime = 0;
    audio.play().catch(() => {});
  };

  audio.addEventListener("ended", handleEnded);

  if (isPlaying) {
    audio.play().catch(() => {});
  }

  return () => {
    audio.removeEventListener("ended", handleEnded);
  };
}, [currentTrack, isPlaying]);


  const play = () => {
    audioRef.current.play();
    setIsPlaying(true);
    localStorage.setItem("sound_enabled", "true");
  };

  const pause = () => {
    audioRef.current.pause();
    setIsPlaying(false);
    localStorage.setItem("sound_enabled", "false");
  };

  const changeTrack = (track) => {
    setCurrentTrack(track);
    localStorage.setItem("sound_track", track);
  };

  return (
    <AudioContext.Provider
      value={{ isPlaying, play, pause, changeTrack, currentTrack }}
    >
      {children}
    </AudioContext.Provider>
  );
};

export const useAudio = () => useContext(AudioContext);
